<div class="bank-account-card">
  <div *ngIf="!isWrittenCheque" ngbAccordion>
    <div
      class="d-flex justify-content-between align-items-center"
      [style.cursor]="'pointer'"
      (click)="toggleAccordionExpand()">
      <div class="d-flex gap-2 flex-column">
        <div class="deposit-title" i18n>Deposited To</div>
        <div class="bank-account-name">{{ bankAccount?.nickname }}</div>
      </div>
      <div>
        <img
          class="accordion-chevron"
          [src]="'assets/icons/light/Chevron Up.svg'"
          [class.expanded]="accordionIsExpanded$ | async"
          [class.collapsed]="!(accordionIsExpanded$ | async)"
          alt="Toggle accordion"
          i18n-alt />
      </div>
    </div>
    <div class="d-flex flex-column gap-3" ngbAccordionItem [collapsed]="!(accordionIsExpanded$ | async)">
      <div ngbAccordionCollapse>
        <div class="bank-info-grid">
          <app-review-entry label="Institution Number" i18n-label [value]="bankAccount?.institutionNumber" />
          <app-review-entry label="Transit Number" i18n-label [value]="bankAccount?.transitNumber" />
          <app-review-entry label="Account Number" i18n-label [value]="bankAccount?.accountNumber" />
        </div>
        <div i18n class="date-added">Date Added: {{ bankAccount?.createdDate | date : 'MMMM d, y' }}</div>
      </div>
    </div>
  </div>
  <div *ngIf="isWrittenCheque" class="bank-account-name" i18n>Written Cheque</div>
</div>
